// From Material-ui nextjs sample https://github.com/mui-org/material-ui/tree/master/examples/nextjs
import { QueryClientProvider } from '@tanstack/react-query';
import { ErrorBoundary } from '../components/errorBoundary';
import { SidebarProvider } from '../components/ui/sidebar';
import { ToastProvider } from '../components/ui/toast';
import { queryClient } from '../lib/react-query';
import { AuthProvider } from '../authentication/authContext';
import { PopupProvider } from '../components/confirmation';
export const AppProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ToastProvider>
            <SidebarProvider>
              <PopupProvider>{children}</PopupProvider>
            </SidebarProvider>
          </ToastProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
};
